import svgPanZoom from 'svg-pan-zoom';
import { FLUXOGRAM_NODE_CLASS } from './config/markup';

export default class API {
  constructor(graph, style) {
    this.graph = graph;
    this.style = style;
  }

  build(holderNode) {
    this.buildFluxogram();
    const pan = this.buildPan(holderNode);

    return { pan };
  }

  buildFluxogram() {
    return window.mermaid.init(undefined, `.${FLUXOGRAM_NODE_CLASS}`);
  }

  buildPan(holderNode) {
    return svgPanZoom(
      holderNode.querySelector('svg'),
      {
        zoomScaleSensitivity: 0.5,
        maxZoom: 20,
        minZoom: 0.1,
      }
    );
  }

  sintaxIsValid() {
    return window.mermaid.parse(this.getCode());
  }

  getCode() {
    return `${this.graph.getCode()}${this.style.get()}`;
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/fluxogram/api.js
 **/